import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import type React from 'react';
import { Fragment, useState } from 'react';
import styled from 'styled-components';

import { IossCurrencies } from '../../../../../../types/currency';
import type { IossCurrency } from '../../../../../../types/currency';
import type { OfferPlanClientDetails } from '../../../../../../types/offers';
import conf from '../../../../conf';
import { embeddedViewRequested } from '../../../../lib/helpers';
import EmptyCartPanel from '../../../buy-flow/empty-cart-panel';
import ExternalLink from '../../../external-link';
import OfferBox from '../../box';
import OfferDetails from '../../offer-details';
import NextButton from '../shared/next-button';
import IossOfferPlan from './ioss-offer-plan';

const CurrencySelect = styled.select`width: 100px;`;

type Props = {
  plans: Array<OfferPlanClientDetails>;
};

const IossPlanSelect = ({ plans }: Props) => {
  const [selectedCurrency, selectCurrency] = useState<IossCurrency>('GBP'); // NOTE (Marlene): This is the default currency.
  const selectedPlan = plans?.find((plan) => plan.currency && plan.currency === selectedCurrency);
  const changeCurrency: React.ChangeEventHandler<HTMLSelectElement> = (e) =>
    selectCurrency(e.target.value as IossCurrency);

  const isEmbedded = embeddedViewRequested();

  return (
    <Fragment>
      <SRow>
        <SCol
          data-ref='buy.plan-select.ioss.column-container'
          span={isEmbedded ? '' : 'md-7 9'}
          className={isEmbedded ? '' : 'pad-bottom-none'}
        >
          <OfferBox isEmbedded={isEmbedded} className='pad-all-sm'>
            <div className='margin-left-sm'>
              <h1>{t('client.headings.get-started-in-four-easy-steps')}</h1>

              <p>
                {t('client.general.already-have-an-account')}
                <ExternalLink href={conf.AA_URL}>{t('client.general.contact-your-account-manager')}</ExternalLink>
                {' to buy the Avalara IOSS Solution'}
              </p>

              <label htmlFor='currency-select'>{t('client.labels.currency')}</label>
              <CurrencySelect
                id='currency-select'
                data-ref='ioss.currency-select'
                onChange={changeCurrency}
                value={selectedCurrency}
              >
                {IossCurrencies.map((currency) => (
                  <option key={currency} value={currency}>
                    {currency}
                  </option>
                ))}
              </CurrencySelect>
            </div>

            <div className='margin-top-lg margin-bottom-xl'>
              <IossOfferPlan />
            </div>

            <NextButton selectedPlanName={selectedPlan?.name || ''} />
          </OfferBox>
        </SCol>

        {!isEmbedded && (
          <SCol span='md-5 3'>
            <EmptyCartPanel />
          </SCol>
        )}
      </SRow>
      {!isEmbedded && (
        <SRow>
          <SCol span='md-7 9'>
            <OfferDetails />
          </SCol>
        </SRow>
      )}
    </Fragment>
  );
};

export default IossPlanSelect;
